export const categories = [
  { id: 1, name: '电视剧', slug: 'tv-series', icon: 'ri-tv-line', count: 2856 },
  { id: 2, name: '电影', slug: 'movies', icon: 'ri-film-line', count: 4210 },
  { id: 3, name: '综艺', slug: 'variety', icon: 'ri-emotion-laugh-line', count: 1532 },
  { id: 4, name: '动漫', slug: 'anime', icon: 'ri-rocket-line', count: 1890 },
  { id: 5, name: '纪录片', slug: 'documentary', icon: 'ri-camera-line', count: 768 },
  { id: 6, name: '少儿', slug: 'kids', icon: 'ri-heart-line', count: 456 },
  { id: 7, name: '短剧', slug: 'short-drama', icon: 'ri-flashlight-line', count: 920 },
  { id: 8, name: '体育', slug: 'sports', icon: 'ri-basketball-line', count: 634 },
];

export const featuredVideos = [
  {
    id: 1,
    title: '长安十二时辰',
    category: '电视剧',
    categorySlug: 'tv-series',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20night%20scene%20with%20lanterns%20and%20traditional%20architecture%2C%20cinematic%20drama%20poster%20style%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20historical%20atmosphere%2C%20movie%20poster%20composition%20with%20Chinese%20characters%20aesthetic&width=800&height=450&seq=video-cover-01&orientation=landscape',
    description: '唐朝天宝三年，上元节前夕，长安城陷入惊天危机。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安。',
    rating: 9.2,
    episodes: 48,
    duration: '45分钟/集',
    updateTime: '2026-08-01',
    views: 12800000,
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'movies',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20massive%20spaceship%20and%20distant%20galaxy%2C%20cinematic%20movie%20poster%20style%2C%20deep%20blue%20and%20orange%20cosmic%20tones%2C%20dramatic%20lighting%2C%20futuristic%20Chinese%20sci-fi%20aesthetic&width=800&height=450&seq=video-cover-02&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开争分夺秒的生死之战。',
    rating: 9.5,
    duration: '148分钟',
    updateTime: '2026-07-28',
    views: 35600000,
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: '繁花',
    category: '电视剧',
    categorySlug: 'tv-series',
    cover: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20cinematic%20drama%20poster%2C%20warm%20golden%20nostalgic%20tones%2C%20classic%20Shanghai%20Bund%20atmosphere%2C%20elegant%20retro%20Chinese%20aesthetic&width=800&height=450&seq=video-cover-03&orientation=landscape',
    description: '九十年代的上海，遍地是机遇与挑战。阿宝凭借改革开放的春风和自己的努力，从平凡青年一步步成为商界翘楚。',
    rating: 9.3,
    episodes: 30,
    duration: '50分钟/集',
    updateTime: '2026-07-25',
    views: 22100000,
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '封神第二部',
    category: '电影',
    categorySlug: 'movies',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20battle%20scene%20with%20warriors%20and%20magical%20creatures%2C%20epic%20fantasy%20movie%20poster%2C%20dramatic%20gold%20and%20crimson%20tones%2C%20Chinese%20mythology%20cinematic%20style&width=800&height=450&seq=video-cover-04&orientation=landscape',
    description: '殷商末年，纣王暴虐无道。姜子牙携封神榜下山，辅助西岐武王伐纣。仙魔大战一触即发，封神榜上的名字正在一个个被刻下。',
    rating: 9.1,
    duration: '156分钟',
    updateTime: '2026-07-20',
    views: 19800000,
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '三体·黑暗森林',
    category: '电视剧',
    categorySlug: 'tv-series',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20cosmic%20scene%20with%20dark%20forest%20silhouette%20and%20distant%20stars%2C%20sci-fi%20thriller%20poster%20style%2C%20deep%20indigo%20and%20silver%20tones%2C%20atmospheric%20and%20philosophical%20Chinese%20sci-fi%20aesthetic&width=800&height=450&seq=video-cover-05&orientation=landscape',
    description: '三体危机出现后，人类组建起庞大的太空舰队，同时制定了"面壁计划"。四名面壁者开始独立策划对抗三体人入侵的秘密策略。',
    rating: 9.4,
    episodes: 30,
    duration: '55分钟/集',
    updateTime: '2026-07-18',
    views: 16700000,
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '哪吒之魔童闹海',
    category: '动漫',
    categorySlug: 'anime',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20scene%20with%20mythological%20characters%20fighting%20sea%20dragons%2C%20vibrant%20animation%20movie%20poster%2C%20bright%20red%20and%20gold%20tones%2C%20dynamic%20Chinese%20animation%20style&width=800&height=450&seq=video-cover-06&orientation=landscape',
    description: '天劫之后，哪吒和敖丙灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，但过程中却遇到重重困难。',
    rating: 9.6,
    duration: '128分钟',
    updateTime: '2026-08-02',
    views: 45200000,
    isHot: true,
    isNew: true,
  },
];

export const rankingVideos = [
  { id: 7, title: '哪吒之魔童闹海', category: '动漫', rating: 9.6, views: 45200000, rank: 1 },
  { id: 8, title: '流浪地球3', category: '电影', rating: 9.5, views: 35600000, rank: 2 },
  { id: 9, title: '三体·黑暗森林', category: '电视剧', rating: 9.4, views: 16700000, rank: 3 },
  { id: 10, title: '繁花', category: '电视剧', rating: 9.3, views: 22100000, rank: 4 },
  { id: 11, title: '长安十二时辰', category: '电视剧', rating: 9.2, views: 12800000, rank: 5 },
  { id: 12, title: '封神第二部', category: '电影', rating: 9.1, views: 19800000, rank: 6 },
  { id: 13, title: '庆余年第二季', category: '电视剧', rating: 9.0, views: 31200000, rank: 7 },
  { id: 14, title: '热辣滚烫', category: '电影', rating: 8.9, views: 28500000, rank: 8 },
  { id: 15, title: '狂飙', category: '电视剧', rating: 8.8, views: 54300000, rank: 9 },
  { id: 16, title: '长津湖之水门桥', category: '电影', rating: 8.7, views: 41200000, rank: 10 },
];

export const latestUpdates = [
  { id: 17, title: '大奉打更人第二季', category: '电视剧', updateEpisode: '第28集', updateTime: '今天 20:00', cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20scene%20with%20ancient%20official%20in%20traditional%20costume%2C%20cinematic%20TV%20drama%20poster%2C%20warm%20amber%20and%20dark%20red%20tones&width=640&height=360&seq=latest-01&orientation=landscape' },
  { id: 18, title: '玫瑰的故事', category: '电视剧', updateEpisode: '第35集', updateTime: '今天 19:00', cover: 'https://readdy.ai/api/search-image?query=Romantic%20modern%20Chinese%20drama%20scene%20with%20elegant%20woman%20among%20roses%2C%20soft%20pink%20and%20warm%20lighting%2C%20cinematic%20TV%20drama%20poster&width=640&height=360&seq=latest-02&orientation=landscape' },
  { id: 19, title: '南来北往', category: '电视剧', updateEpisode: '第22集', updateTime: '今天 18:00', cover: 'https://readdy.ai/api/search-image?query=Chinese%20railway%20train%20journey%20through%20scenic%20landscape%2C%20nostalgic%20drama%20poster%20style%2C%20warm%20nostalgic%20green%20and%20gold%20tones&width=640&height=360&seq=latest-03&orientation=landscape' },
  { id: 20, title: '凡人修仙传', category: '动漫', updateEpisode: '第89集', updateTime: '今天 17:30', cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20fantasy%20animation%20scene%20with%20floating%20mountains%20and%20immortal%20warrior%2C%20ethereal%20purple%20and%20gold%20tones%2C%20Chinese%20animation%20style&width=640&height=360&seq=latest-04&orientation=landscape' },
  { id: 21, title: '奔跑吧·生态篇', category: '综艺', updateEpisode: '第12期', updateTime: '今天 16:00', cover: 'https://readdy.ai/api/search-image?query=Outdoor%20Chinese%20variety%20show%20scene%20with%20celebrities%20playing%20games%20in%20nature%2C%20bright%20and%20energetic%20poster%2C%20vibrant%20green%20and%20sunny%20tones&width=640&height=360&seq=latest-05&orientation=landscape' },
  { id: 22, title: '深海危机', category: '电影', updateEpisode: 'HD高清', updateTime: '今天 15:00', cover: 'https://readdy.ai/api/search-image?query=Underwater%20thriller%20scene%20with%20submarine%20and%20deep%20ocean%20darkness%2C%20suspenseful%20movie%20poster%20style%2C%20deep%20navy%20blue%20and%20teal%20tones&width=640&height=360&seq=latest-06&orientation=landscape' },
  { id: 23, title: '舌尖上的中国·第四季', category: '纪录片', updateEpisode: '第6集', updateTime: '今天 14:30', cover: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20traditional%20dishes%20closeup%2C%20warm%20appetizing%20tones%2C%20cinematic%20food%20photography%20style&width=640&height=360&seq=latest-07&orientation=landscape' },
  { id: 24, title: '英雄联盟·双城之战2', category: '动漫', updateEpisode: '第9集完结', updateTime: '今天 13:00', cover: 'https://readdy.ai/api/search-image?query=Steampunk%20animation%20cityscape%20with%20two%20contrasting%20societies%2C%20cinematic%20anime%20poster%2C%20rich%20gold%20and%20dark%20blue%20contrast%20tones&width=640&height=360&seq=latest-08&orientation=landscape' },
];

export const siteInfo = {
  name: '玫瑰视频',
  slogan: '聚合热门资源 · 畅享流畅观影',
  description: '玫瑰视频是一个聚合全网高清影视资源的在线视频平台，提供电视剧全集、电影大全、热播综艺、人气动漫等海量内容。我们致力于为用户提供不缓冲、高清免费的观影体验，让每一位观众都能随时随地畅享精彩内容。',
  founded: '2018年',
  totalViews: '12.8亿+',
  totalUsers: '5800万+',
  totalContent: '10万+',
};